import { AfterViewInit, Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'web-promo-shared-pattern-lib-ads-carousel-popup',
  imports: [CarouselModule],
  templateUrl: './lib-ads-carousel-popup.component.html',
  styleUrl: './lib-ads-carousel-popup.component.scss',
})
export class LibAdsCarouselPopupComponent implements AfterViewInit {
  private readonly loggingService = inject(LoggingService);
  public readonly replaceBucket = new ReplaceBucket();
  carouselOptions = {
    loop: true,
    nav: true, // Enable navigation
    dots: false,
    lazyLoad: true,
    autoplay: true,
    autoplayTimeout: 3000,
    navText: ['<i class="fa fa-angle-left" style="align-content:center;"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: {
        items: 1, // Show 1.5 items on smaller screens
        // stagePadding: 10,
      },
    },
  };

  ngAfterViewInit() {
    this.loggingService.warn('@@@ carousel popup resize@@@');

    setTimeout(() => {
      this.loggingService.warn('@@@ carousel popup resize@@@ setTimeout');
      window.dispatchEvent(new Event('resize'));
    });
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<LibAdsCarouselPopupComponent>
  ) {
    this.loggingService.warn('@@@ carousel popup @@@', data().rows);
  }

  closeDialog() {
    this.dialogRef.close('close');
  }
}
